import moment from 'moment';
import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import InboxService from '../Services/InboxService';
import { useEffect, useState } from 'react';
import InboxTagsButton from './InboxTagsButton';
import EmailService from '../Services/EmailService';
import PubSub from 'pubsub-js';
import InboxInlineCompose from './InboxInlineCompose';


function InboxEmailDetail({ onPrevEmail, onNextEmail, onRefresh }) {

    const { id } = useParams();

    const [thread, setThread] = useState({
        messages: []
    });

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const search = params.toString();

    const isUnread = thread?.last_labels && thread.last_labels?.includes('UNREAD');
    const [markedAsRead, setMarkedAsRead] = useState(false);


    useEffect(() => {
        getMessagesForThread();
    }, [id])

    useEffect(() => {
        if (isUnread && thread.account && !markedAsRead) {
            markEmailAsReadBackground(thread.account, id, isUnread);
        }
    }, [thread])

    function openInlineCompose(email, i) {
        email.compose = true;
        thread.messages[i] = email;
        setThread({ ...thread })
    }

    function closeInlineCompose(email, i) {
        email.compose = false;
        thread.messages[i] = email;
        setThread({ ...thread })
    }

    async function getMessagesForThread() {
        let thread = await InboxService.getMessagesByThreadId(id)
        setThread(thread)
    }

    async function sendReplyEmail(email, recipients, body) {

        const to = recipients.map(e => e.value).join(',');

        const params = {
            from: email.account,
            to,
            subject: email.subject,
            body,
            threadId: email.thread_id
        };

        PubSub.publish('loading.notification', { message: 'Sending email...', show: true });
        const { message } = await InboxService.sendReplyEmail(params);
        PubSub.publish('loading.notification.hide');

        alert(message);
        await getMessagesForThread();

    }


    function renderEmail(email, i) {
        return (<div className='mt-2' key={i}>
            <div className='d-flex justify-content-between my-3'>

                <div className="text-muted fs-12 d-flex">
                    <img className='inbox-profile-img' src="https://lh3.googleusercontent.com/a/default-user=s80-p" alt="" />
                    <div className='ms-3'>
                        <div className='bold'>{email.from_formatted}</div>
                        <div className='bold'>{email.to}</div>
                    </div>

                </div>
                <div className="text-muted fs-12">{moment(email.internal_date).format('MMM DD, yyyy, hh:mm a')}</div>
            </div>
            <div
                className='inbox-email-content'
                dangerouslySetInnerHTML={{ __html: email.bodyHtml }} />
            <div>
                <button
                    onClick={() => openInlineCompose(email, i)}
                    className="inbox-reply-button">
                    <i className="fa-solid fa-reply me-2"></i>
                    Reply
                </button>
                <button className="inbox-reply-button">
                    <i className="fa-solid fa-share me-2"></i>
                    Forward
                </button>
            </div>
            <hr />
            {renderComposeReply(email, i)}

        </div>)
    }

    function renderComposeReply(email, i) {
        if (email.compose !== true) {
            return null;
        }

        return (
            <InboxInlineCompose
                email={email}
                recipients={thread.recipients}
                onSend={sendReplyEmail}
                onClose={() => closeInlineCompose(email, i)}
            />
        );
    }

    function renderEmails() {
        return (<div>
            {thread.messages.map((email, i) => renderEmail(email, i))}
        </div>)
    }

    async function markEmailAsReadBackground(account, thread_id, read) {
        let data = await EmailService.markEmailAsRead({
            account,
            thread_id,
            read
        });
        setMarkedAsRead(true);
        onRefresh();
        setLoading(false);
        getMessagesForThread();
    }

    async function markEmailAsRead(account, thread_id, read) {
        PubSub.publish('loading.notification', {
            message: 'Marking email as read',
            show: true
        });
        setLoading(true);
        let { message } = await EmailService.markEmailAsRead({
            account,
            thread_id,
            read
        });
        onRefresh();
        setLoading(false);
        backToInbox();
        PubSub.publish('loading.notification.hide');
    }

    async function syncThread() {
        setLoading(true);
        let { message } = await InboxService.syncThreadById(thread.account, id);
        alert(message);
        setLoading(false);
        await getMessagesForThread();
        onRefresh();
    }

    function backToInbox() {
        navigate(`/admin/inbox?${search}`);
    }

    return (
        <div className='inbox-detail-container'>

            <div className='inbox-detail-buttons'>
                <NavLink
                    data-tooltip-id="inbox-tooltip"
                    className="inbox-button"
                    to={`/admin/inbox?${search}`}
                    data-tooltip-content="Back to inbox"
                >
                    <i className="fa-solid fa-arrow-left"></i>
                </NavLink>


                <button
                    data-tooltip-id="inbox-tooltip"
                    className="inbox-button"
                    data-tooltip-content="Archive"
                >
                    <i className="fa-solid fa-box-archive"></i>
                </button>

                <button
                    data-tooltip-id="inbox-tooltip"
                    className="inbox-button"
                    data-tooltip-content="Delete"
                >
                    <i className="fa-solid fa-trash-can"></i>
                </button>
                <button
                    data-tooltip-id="inbox-tooltip"
                    className="inbox-button"
                    disabled={loading}
                    onClick={() => markEmailAsRead(thread.account, id, isUnread)}
                    data-tooltip-content={isUnread ? 'Mark as read' : 'Mark as unread'}
                >
                    {!isUnread ? <i className="fa-regular fa-envelope"></i> : <i className="fa-solid fa-envelope-open"></i>}
                </button>

                <InboxTagsButton
                    onRefresh={() => {
                        getMessagesForThread()
                        onRefresh()
                    }}
                    thread_id={id}
                    existing_tags={thread.local_labels} />

                <button
                    data-tooltip-id="inbox-tooltip"
                    className="inbox-button"
                    onClick={syncThread}
                    data-tooltip-content="Sync thread"
                >
                    <i className="fa-solid fa-rotate-right"></i>
                </button>

                <button
                    data-tooltip-id="inbox-tooltip"
                    className="inbox-button"
                    onClick={() => onPrevEmail(id)}
                    data-tooltip-content="Previous email"
                    style={{ marginLeft: 'auto' }}
                >
                    <i className="fa-solid fa-arrow-left"></i>
                </button>

                <button
                    data-tooltip-id="inbox-tooltip"
                    className="inbox-button"
                    onClick={() => onNextEmail(id)}
                    data-tooltip-content="Next email"
                >
                    <i className="fa-solid fa-arrow-right"></i>
                </button>
            </div>

            <div className='inbox-detail-subject'>
                {thread.subject}
            </div>

            <div>
                {renderEmails()}
            </div>
        </div>
    )

}

export default InboxEmailDetail;